module.exports = __webpack_public_path__ + "static/media/mobile_background.9639fbc7.svg";